import React, { PropTypes } from 'react';
import Burger from '../containers/Burger';
import BgSlider from '../containers/BgSlider';
import { withRouter } from 'react-router';
import konami from 'konami-komando';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import Loader from 'react-loader';
import classNames from 'classnames';
import LangSwitch from './LangSwitch';

const wheel = (e, props) => {
  if (!props.showSection && !props.lockedSlider) {
    const timeNow = new Date().getTime();
    if (timeNow - document.wheelExpiration > 1000) {
      const rawdelta = (typeof e.wheelDelta === 'undefined') ? -e.deltaY : e.wheelDelta;
      const delta = (rawdelta % 120 === 0) ? rawdelta / 120 : rawdelta / 3;
      if (Math.abs(delta) > 2) {
        props.onWheel(delta, props.lang, props.prevnext);
        document.wheelExpiration = timeNow;
      }
    }
  }
};

class App extends React.Component {
  componentWillMount() {
    this.props.setNavOnlyFromUri(this.props.location.pathname);
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      konami({ once: false, callback: this.props.onKonami });
      document.wheelExpiration = 0;
      document.addEventListener('wheel', (e) => wheel(e, this.props));
      window.addEventListener('keydown', (e) =>
        this.props.onKeyDown(e, this.props.uris, this.props.lang, this.props.prevnext));
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('wheel', (e) => wheel(e, this.props));
      window.removeEventListener('keydown', (e) =>
        this.props.onKeyDown(e, this.props.uris, this.props.lang, this.props.prevnext));
    }
  }

  render() {
    const { menu, section, location, showSection, uris,
      ready, openedBurger, baseline, lang, langSwitch } = this.props;
    return (
      <div>
        <Loader loaded={ready} color="#FFF" hwaccel width={3} length={10} radius={15} />
        <div style={{ transition: 'opacity 1s ease', opacity: ready ? 1 : 0 }}>
          <BgSlider location={location} />
          <Burger />
          <LangSwitch lang={lang} uris={uris} toggle={langSwitch} />
          <CSSTransitionGroup
            transitionName="nav"
            transitionAppearTimeout={1500}
            transitionEnterTimeout={1500}
            transitionLeaveTimeout={1500}
            transitionAppear
          >
            <nav>
              <div
                className={classNames(
                  'navcontent',
                  { appear: !openedBurger, disappear: openedBurger }
                )}
              >
                <div className="navcenter">
                  <h1>
                    <span className="prenom">Mario</span>
                    <span className="nom">Luraschi</span>
                  </h1>
                  <h2>{baseline}</h2>
                  {menu}
                </div>
              </div>
            </nav>
          </CSSTransitionGroup>
          <CSSTransitionGroup
            transitionName="section"
            transitionEnterTimeout={1500}
            transitionLeaveTimeout={1500}
          >
            {(showSection) ? section : null}
          </CSSTransitionGroup>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  menu: PropTypes.object,
  section: PropTypes.object,
  actions: PropTypes.object.isRequired,
  prevnext: PropTypes.arrayOf(PropTypes.object).isRequired,
  lang: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  uris: PropTypes.object.isRequired,
  showSection: PropTypes.bool.isRequired,
  ready: PropTypes.bool.isRequired,
  openedBurger: PropTypes.bool.isRequired,
  lockedSlider: PropTypes.bool.isRequired,
  baseline: PropTypes.string.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onKonami: PropTypes.func.isRequired,
  setNavOnlyFromUri: PropTypes.func.isRequired,
  onWheel: PropTypes.func.isRequired,
  langSwitch: PropTypes.func.isRequired,
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./common/components/App.js